import { BREAKPOINTS } from '@constants/common'
import { WindowSizeContext } from '@context/WindowSize/Context'
import React, { useContext } from 'react'
import { ParticipantsVoicePcLayout } from './PcLayout'
import { ParticipantsVoiceSpLayout } from './Splayout'

type Props = {
  content: string
  participantInfo: string
}

export const ParticipantsVoiceItem = (props: Props): JSX.Element => {
  const winSize = useContext(WindowSizeContext)

  return winSize?.width > BREAKPOINTS.laptop ? (
    <ParticipantsVoicePcLayout {...props} />
  ) : (
    <ParticipantsVoiceSpLayout {...props} />
  )
}
